import { useStarterDashboardV2PageData } from 'src/app/pages/starterDashboardV2/pageContext';

import { usePageBanner } from '../../components/PageBanner/hooks/usePageBanner';

export function usePageBody() {
	const {
		data: {
			petition,
			shareRecommendations,
			viewer: {
				experiments: { starterExperienceDashboardReadyToShareV1 },
			},
		},
	} = useStarterDashboardV2PageData();
	const {
		data: { banner },
	} = usePageBanner();
	const shouldShowUnderReview = petition.status === 'UNDER_REVIEW';

	const bannerHeight = banner ? document.getElementById('starter-dashboard-banner')?.clientHeight : 0;
	const shouldShowReadyToShareExperiment = starterExperienceDashboardReadyToShareV1.variation === 'variant1';

	return {
		data: {
			shouldShowUnderReview,
			shareRecommendationsEnabled: shareRecommendations.shareRecommendationsEnabled,
			bannerHeight,
			shouldShowReadyToShareExperiment,
		},
	};
}
